<template>
  <VSnackbars
    :objects.sync="$snackMessages.objects"
    v-bind="$attrs"
  >
    <template v-slot:action="{ close, message }">
      <div
        v-if="message.includes('...')"
      >
        <v-progress-circular
          indeterminate
          :width="2"
          :size="24"
        ></v-progress-circular>
      </div>
      <v-icon v-else @click="close()">{{ mdiClose }}</v-icon>
    </template>
  </VSnackbars>
</template>

<script>
import VSnackbars from 'v-snackbars'
import {
  mdiClose
} from '@mdi/js'

export default {
  name: 'SnackMessages',
  components: {
    VSnackbars
  },
  data: () => ({
    mdiClose
  })
}
</script>
